// src/components/SaleCancelForm/SaleCancelPanel.tsx
import React from 'react';
import SaleCancelForm from './SaleCancelForm';
import SaleCancelReasonSection from './SaleCancelReasonSection';
import SaleCancelSectionHeader from './SaleCancelSectionHeader';
import { useSaleInvalidation } from '../../../hooks/sale/useSaleInvalidation';
import ReplacementSaleSelector from './ReplacementSaleSelector';
import SaleFoundCard from './SaleFoundCard';

const SaleCancelPanel: React.FC = () => {
  const {
    form,
    foundSaleToInvalidate,
    foundReplacementSale,
    submitInvalidation,
  } = useSaleInvalidation();

  const requiresReplacement =
    form.invalidationTypeCode === '1' || form.invalidationTypeCode === '3';

  const handleSubmit = () => {
    submitInvalidation();
  };

  return (
    <div className="flex flex-col divide-y divide-stroke dark:divide-strokedark">
      {/* 1️⃣ Datos para buscar venta a anular */}
      <div className="p-6">
        <SaleCancelSectionHeader
          title="Identificación del DTE a anular"
          description="Selecciona el motivo y escribe el código de generación del DTE."
        />
        <SaleCancelForm />
      </div>

      {/* 2️⃣ Secciones condicionales basadas en el tipo */}
      {!!form.invalidationTypeCode && (
        <>
          {/* 2️⃣ Mostrar solo si hay venta encontrada */}
          {foundSaleToInvalidate && (
            <div className="p-6">
              <SaleCancelSectionHeader
                title="Detalles de la venta encontrada"
                description="Información obtenida según el código de generación proporcionado."
              />
              <SaleFoundCard data={foundSaleToInvalidate} />
            </div>
          )}

          {/* 3️⃣ Mostrar reemplazo solo si aplica */}
          {requiresReplacement && (
            <div className="p-6">
              <SaleCancelSectionHeader
                title="Buscar venta que reemplaza"
                description="Selecciona la venta nueva que reemplaza al documento anterior."
              />
              <ReplacementSaleSelector />
              {foundReplacementSale && (
                <SaleFoundCard data={foundReplacementSale} className="mt-4" />
              )}
            </div>
          )}
        </>
      )}

      {/* 4️⃣ Justificación */}
      <div className="p-6">
        <SaleCancelSectionHeader
          title="Justificación del evento de anulación"
          description="Describe claramente el motivo por el cual se desea invalidar este documento. Este campo será enviado a Hacienda."
        />
        <SaleCancelReasonSection onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default SaleCancelPanel;
